export default "__VITE_ASSET__b74f88a7__"